import React, { memo } from 'react';

const RowIndexComponent = ({ rowIndex }) => <b>{rowIndex + 1}</b>;

export const RowIndex = memo(RowIndexComponent);
